<ng-container *ngIf="!!get && !!form" [formGroup]="form">
    <tt-input *ngIf="get.setting_show_oh_head_invoice_cust_no !== '0'" ttLabel="orderhead_invoice_cust_no" formControlName="invoice_cust_no" ttReadonly>
        <ng-container buttons>
            <tt-form-field-button
                ttIcon="fas fa-chevron-right"
                ttTooltip="goto_customersmenu"
                [ttTranslateTooltip]="true"
                ttGoto="customersmenu"
                [ttGotoParms]="{ cust_no: '' + form.controls.invoice_cust_no.value }"
            ></tt-form-field-button>
        </ng-container>
    </tt-input>
    <tt-search
        *ngIf="get.setting_show_oh_head_invoice_cust_name !== '0'"
        ttLabel="orderhead_invoice_cust_name"
        formControlName="invoice_cust_name"
        [ttSearch]="searchCustomers"
        (ttOnSelected)="onInvoiceCustomerSelected($event)"
        (ttOnClear)="onInvoiceCustomerSelected()"
    ></tt-search>
    <tt-textarea *ngIf="get.setting_show_oh_head_invoice_cust_address !== '0'" ttLabel="orderhead_invoice_cust_address" formControlName="invoice_cust_address" ttReadonly></tt-textarea>
    <tt-input *ngIf="get.setting_show_oh_head_invoice_country_id !== '0'" ttLabel="orderhead_invoice_country_id" formControlName="invoice_country_id" ttReadonly></tt-input>
    <tt-select
        *ngIf="get.setting_show_oh_head_invoice_business_id !== '0'"
        ttLabel="business"
        formControlName="invoice_business_id"
        [ttData]="businesses"
        ttDataId="business_id"
        ttDataName="business_name"
    >
        <ng-container buttons>
            <tt-form-field-button ttIcon="fas fa-chevron-right" ttTooltip="goto_businesss" [ttTranslateTooltip]="true" ttGoto="businesss"></tt-form-field-button>
        </ng-container>
    </tt-select>
    <tt-select *ngIf="get.show_oh_head_invoice_coop_id === '1'" ttLabel="coop" formControlName="invoice_coop_id" [ttData]="coops" ttDataId="coop_id" ttDataName="coop_name"></tt-select>
</ng-container>
